module.exports = __webpack_public_path__ + "static/media/language-icon.5d08ccab.svg";